import { useCallback, useContext, useState, createContext } from "react"
import { Alert, Snackbar } from "@mui/material"

export type Toast = {
	message: string
	severity: "error" | "warning" | "info" | "success"
}

const GlobalToastContext = createContext<(toast: Toast) => void>(() => {})

export type Props = {
	children?: React.ReactNode
}

export const useAddGlobalToast = () => useContext(GlobalToastContext)

export const GlobalToastProvider: React.FC<Props> = ({ children }) => {
	const [toast, setToast] = useState<Toast | null>(null)

	const addToast = useCallback((addedToast: Toast) => setToast(addedToast), [setToast])

	return (
		<GlobalToastContext.Provider value={addToast}>
			{children}
			<Snackbar
				autoHideDuration={5_000}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				open={!!toast}
				onClose={() => setToast(null)}
			>
				<Alert
					severity={toast?.severity}
					onClose={() => setToast(null)}
					variant="filled"
					sx={{ width: "100%" }}
				>
					{toast?.message}
				</Alert>
			</Snackbar>
		</GlobalToastContext.Provider>
	)
}
